"use client";

import type { ReactNode } from "react";
import { AnonymizedBadge } from "@/components/ui/anonymized-badge";
import {
  TooltipContent,
  TooltipTrigger,
} from "../../../../../components/ui/tooltip";
import { TruncateTooltip } from "../../../../../components/ui/truncate-tooltip";

type AnonymizedCellProps = {
  isAnonymized: boolean;
  anonymizedTooltipMessage: ReactNode;
  learnMoreUrl: string;
  value: ReactNode;
};

export const AnonymizedCell = ({
  isAnonymized,
  anonymizedTooltipMessage,
  learnMoreUrl,
  value,
}: AnonymizedCellProps) => {
  if (isAnonymized) {
    return (
      <AnonymizedBadge
        tooltipMessage={anonymizedTooltipMessage}
        learnMoreUrl={learnMoreUrl}
      />
    );
  }
  return (
    <div className="flex whitespace-normal">
      <TruncateTooltip>
        <TooltipTrigger asChild>
          <span className="break-all line-clamp-2 overflow-hidden">
            {value}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{value}</p>
        </TooltipContent>
      </TruncateTooltip>
    </div>
  );
};
